const foodOptions = [
  'GLUTEN_FREE',
  'LACTOSE_FREE',
  'MILK_PROTEIN_FREE',
  'VEGETARIAN',
  'VEGAN',
];

export default foodOptions;
